<template>
  <div class="sideber" :class="headerSelect == 2 ? 'hr' : ''">
    <div class="sideberBox">
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
          :default-active="activeMenu"
          :unique-opened="false"
          :collapse-transition="false"
          mode="vertical"
        >
          <sidebar-item
            v-for="route in routes"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          />
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import SidebarItem from "./SidebarItem";
export default {
  components: { SidebarItem },
  data() {
    return {
      headerSelect: this.$store.state.headerSelect
    };
  },
  computed: {
    routes() {
      let _routes = "";
      if (this.headerSelect == 2) {
        _routes = this.$router.options.routes.filter(function(item) {
          return item.path.includes("/hr");
        });
      } else {
        _routes = this.$router.options.routes.filter(function(item) {
          return !item.path.includes("/hr");
        });
      }
      return _routes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  },
  watch: {
    "$store.state.headerSelect": function(e) {
      this.headerSelect = e;
    }
  }
};
</script>
<style lang="scss">
.sideber {
  background-image: url("~@/assets/images/layout/layoutbg.png");
  background-size: cover;
  background-color: #ffffff;
  overflow: hidden;
  height: calc(100vh - 54px);
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  z-index: 99;
  & > .sideberBox {
    padding: 30px 10px 30px 10px;
    height: 100%;
    & > div {
      height: 100%;
      .scrollbar-wrapper {
        overflow-x: hidden;
        margin-bottom: 0 !important;
      }
    }
    .el-menu {
      border: 0;
      .el-menu-item {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        border-radius: 24px;
        i {
          color: inherit;
          font-weight: 400;
          margin-right: 15px;
        }
      }

      .el-menu-item,
      .el-submenu__title {
        height: 40px;
        line-height: 38px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 10px;
        border-radius: 24px;
      }
      .el-submenu .el-menu-item {
        padding: 0;
        min-width: 0;
        i {
          margin-right: 10px;
        }
      }
      .router-link-active {
        li {
          background: #2d8aee;
          box-shadow: 0px 2px 5px 0px rgba(16, 206, 224, 0.17);
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }
}
.hr.sideber {
  background-image: url("~@/assets/images/layout/layout_hrbg.png");
  & > .sideberBox .el-menu .router-link-active li {
    background: #2ca063;
  }
}
</style>
